export default {
	entryPage: {
		title: "Startseite",
		hint: "Eine HTML-Seite, die als Einstieg jedes Dataspace angezeigt wird, der dieses Projekt ausführt. Mit eingebettetem CSS und JavaScript schreiben.",
		editorLabel: "HTML der Startseite",
		enabledLabel: "Diese Seite beim Öffnen eines Dataspace anzeigen",
		enabledHint: "Ausgeschaltet öffnet der Dataspace wie bisher mit seiner Prozessliste.",
		unsavedNotShipped:
			"Es gibt ungespeicherte Änderungen: Der Schalter wirkt auf die zuletzt gespeicherte Seite, und die liefert ein Build aus.",
		enabledOn: "Die Startseite ist eingeschaltet. Der nächste Build liefert sie aus.",
		enabledOff: "Die Startseite ist ausgeschaltet.",
		publicNotice:
			"Die Werte der Variablen, die diese Seite liest (process.env.NAME), sind für alle Mitglieder des Dataspace und für jeden sichtbar, der die Seite öffnen kann. Hier keine Geheimnisse lesen.",
		saved: "Startseite gespeichert.",
		resetAction: "Zurücksetzen",
		resetConfirm: "Die Startseite verwerfen und ausschalten?",
		reset: "Startseite zurückgesetzt.",
		tooLarge: "Die Seite ist {size} KiB groß; gespeichert werden höchstens {max} KiB.",
		notice: "Die Seite läuft in einer Sandbox. Sie kann ihre eigenen Variablen lesen und window.notitia aufrufen — sonst nichts von der App. openProcesses() und openProcess(id, options) öffnen den Operator; die Optionen nehmen eine query. startProcess(name, options) startet einen Prozess und liefert seine ID, sobald er bereit ist; die Optionen nehmen instanceName, description und restartRule, jede davon optional. sendEvent(target, event, data) sendet das Ereignis mit dem Namen event — worauf eine Aktion „Ereignis empfangen“ wartet — an eine Prozess-ID oder, wenn das Ziel einen Prozess nennt, an alle laufenden Instanzen, und liefert, wie viele es erreicht hat. Eine Ablehnung ist ein Error, dessen code den Grund nennt.",
		previewTitle: "Vorschau",
		previewFrame: "Vorschau der Startseite",
		previewEnvTitle: "Werte für die Vorschau",
		previewEnvHint:
			"Platzhalterwerte, nicht gespeichert. In einem Dataspace erhält die Seite die dort gesetzten Werte.",
		previewNoEnv: "Diese Seite liest keine Umgebungsvariablen.",
		previewBridge:
			"{call} funktioniert nur in einem Dataspace; in der Vorschau passiert nichts.",
		previewRefused: "Ein Dataspace würde diese Anfrage der Seite ablehnen: {message}",
	},
};
